import { useEffect, useState } from 'react'

import { getAboutPanels } from '../Contentful'

export default function useAboutPanels() {
  const promise = getAboutPanels()
  // console.log("test 3");
  const [aboutPanels, setAboutPanels] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    promise.then(result => {
      setAboutPanels(result)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [aboutPanels, isLoading]
}